import { useContext, useEffect } from "react";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import UploadMedia from "../../../helpers/UploadMedia/UploadMedia";
import { settingAdminContext } from "../../../context/Admin/SettingAdminContext/SettingAdminContext";

const SettingAdmin = () => {
  const setting = useSelector((state) => state.meta?.setting);

  const {
    logo,
    setLogo,
    title,
    setTitle,
    phoneNumber,
    setPhoneNumber,
    address,
    setAddress,
    morningShift,
    setMorningShift,
    eveningShift,
    setEveningShift,
    handleEditSetting,
  } = useContext(settingAdminContext);

  const handleReset = () => {
    setLogo(setting?.logo);
    setTitle(setting?.title);
    setPhoneNumber(setting?.phoneNumber);
    setAddress(setting?.address);
    setMorningShift(setting?.morningShift);
    setEveningShift(setting?.eveningShift);
  };

  useEffect(() => {
    if (!isEmpty(setting)) handleReset();
  }, [setting]);

  return (
    <>
      <SiteTitle title="تنظیمات" />

      <div className="container-fluid mt-4">
        <form onSubmit={handleEditSetting}>
          <div className="card mb-2">
            <div className="card-header text-dark">آدرس لوگو</div>
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-3">
                  <UploadMedia callback={(val) => setLogo(val)} />
                </div>
                <div className="col-12 col-md-6 col-lg-9">
                  <div className="kf-field bg-dark">
                    <input
                      type="text"
                      id="logo"
                      name="logo"
                      placeholder="آدرس لوگو"
                      onChange={(e) => setLogo(e.target.value)}
                      value={logo}
                    />
                    <i className="la la-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card mb-2">
            <div className="card-header text-dark">عنوان سایت</div>
            <div className="card-body">
              <div className="kf-field bg-dark">
                <input
                  type="text"
                  id="title"
                  name="title"
                  placeholder="عنوان سایت"
                  onChange={(e) => setTitle(e.target.value)}
                  value={title}
                />
                <i className="la la-image" />
              </div>
            </div>
          </div>
          <div className="card mb-2">
            <div className="card-header text-dark">شماره تماس</div>
            <div className="card-body">
              <div className="kf-field bg-dark">
                <input
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="شماره تماس"
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  value={phoneNumber}
                />
                <i className="la la-image" />
              </div>
            </div>
          </div>
          <div className="card mb-2">
            <div className="card-header text-dark">آدرس</div>
            <div className="card-body">
              <div className="kf-field bg-dark">
                <input
                  type="text"
                  id="address"
                  name="address"
                  placeholder="آدرس"
                  onChange={(e) => setAddress(e.target.value)}
                  value={address}
                />
                <i className="la la-image" />
              </div>
            </div>
          </div>
          <div className="card mb-2">
            <div className="card-header text-dark">ساعت شیفت صبح</div>
            <div className="card-body">
              <div className="kf-field bg-dark">
                <input
                  type="text"
                  id="morningShift"
                  name="morningShift"
                  placeholder="ساعت شیفت صبح"
                  onChange={(e) => setMorningShift(e.target.value)}
                  value={morningShift}
                />
                <i className="la la-image" />
              </div>
            </div>
          </div>
          <div className="card mb-2">
            <div className="card-header text-dark">ساعت شیفت عصر</div>
            <div className="card-body">
              <div className="kf-field bg-dark">
                <input
                  type="text"
                  id="eveningShift"
                  name="eveningShift"
                  placeholder="ساعت شیفت عصر"
                  onChange={(e) => setEveningShift(e.target.value)}
                  value={eveningShift}
                />
                <i className="la la-image" />
              </div>
            </div>
          </div>

          <div className="kf-bts mt-4">
            <button className="kf-btn" type="submit">
              <span>ویرایش</span>
            </button>

            <button
              type="button"
              className="btn btn-danger me-2"
              onClick={handleReset}
            >
              بازنشانی
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default SettingAdmin;
